import { useSelector } from "react-redux";
import RootState from "store/state";

export default function useAuth() {

    const auth = useSelector<RootState, RootState["auth"]>(
        ({ auth }) => auth
    )
    
    return auth;
}